import React, { useState, useEffect } from 'react';
import { jobAPI } from '../../services/api';
import './JobStats.css';

const JobStats = ({ user }) => {
  const [stats, setStats] = useState({
    totalJobs: 0,
    activeJobs: 0,
    totalApplications: 0,
    pendingApplications: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchJobStats();
    }
  }, [user]);

  const fetchJobStats = async () => {
    if (!user) {
      setStats({
        totalJobs: 0,
        activeJobs: 0,
        totalApplications: 0,
        pendingApplications: 0,
      });
      setLoading(false);
      return;
    }
    
    setLoading(true);
    try {
      console.log('JobStats: Fetching stats for user:', user.id);
      // Fetch stats using single optimized endpoint
      const statsResponse = await jobAPI.getStats();
      
      console.log('JobStats: Stats response:', statsResponse);
      
      if (statsResponse.success && statsResponse.data) {
        setStats({
          totalJobs: statsResponse.data.totalJobs || 0,
          activeJobs: statsResponse.data.activeJobs || 0,
          totalApplications: statsResponse.data.totalApplications || 0,
          pendingApplications: statsResponse.data.pendingApplications || 0,
        });
      } else {
        console.warn('JobStats: API returned success=false:', statsResponse);
        setStats({
          totalJobs: 0,
          activeJobs: 0,
          totalApplications: 0,
          pendingApplications: 0,
        });
      }
    } catch (err) {
      console.error('JobStats: Error fetching job stats:', err);
      setStats({
        totalJobs: 0,
        activeJobs: 0,
        totalApplications: 0,
        pendingApplications: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="job-stats-card">
        <div className="job-stats-section">
          <div className="job-stats-loading">
            <div className="job-stats-spinner"></div>
            <span>Loading job stats...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="job-stats-card">
      <div className="job-stats-section">
        <div className="job-stats-header">
          <div className="job-stats-header-content">
            <h3>Job Statistics</h3>
          </div>
        </div>
        
        <div className="job-stats-grid">
          <div className="job-stats-stat-card">
            <div className="job-stats-card-content">
              <div className="job-stats-stat-value">{stats.totalJobs}</div>
              <div className="job-stats-stat-label">Total Jobs</div>
            </div>
          </div>

          <div className="job-stats-stat-card">
            <div className="job-stats-card-content">
              <div className="job-stats-stat-value">{stats.activeJobs}</div>
              <div className="job-stats-stat-label">Active Jobs</div>
            </div>
          </div>

          <div className="job-stats-stat-card">
            <div className="job-stats-card-content">
              <div className="job-stats-stat-value">{stats.totalApplications}</div>
              <div className="job-stats-stat-label">Applications</div>
            </div>
          </div>

          <div className="job-stats-stat-card">
            <div className="job-stats-card-content">
              <div className="job-stats-stat-value">{stats.pendingApplications}</div>
              <div className="job-stats-stat-label">Pending Review</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobStats;

